import { Injectable, EventEmitter, Inject } from '@angular/core';
import { map } from 'lodash';
import { DOCUMENT } from '@angular/common';

@Injectable()
export class SearchPageService {

  headerMinScrollDelta: number = 151; // Scroll size between big header and small header
  rowHeight: number = 51;

  uiModel: any = {
    isHeaderFixed: false,
    isSearchFormOpened: false,
    isSortingCollapsed: false,
    headerMinHeight: 200,
  };

  constructor(
    @Inject(DOCUMENT) private document: any,
  ) {}

  expandHeader(expand: boolean = true) {
    this.uiModel.isHeaderFixed = false;
  }

  /*
    * Prohibit reducing header if there is not ehought height for scrolling
  */
  get isScrollingProhibited(): Boolean {
    return (this.document.body.scrollHeight - this.headerMinScrollDelta)
      <= (window.innerHeight + this.rowHeight) && !this.uiModel.isHeaderFixed;
  }
}
